import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import './index.css';
import App from './Components/App/App';
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import "@fortawesome/fontawesome-free/css/all.min.css";
import CssBaseline from '@material-ui/core/CssBaseline';
// import { IntercomProvider, useIntercom } from 'react-use-intercom';

// const INTERCOM_APP_ID = 'cxb5m30v';

ReactDOM.render(
  <React.StrictMode>
  <CssBaseline />

  <BrowserRouter>
  {/*<IntercomProvider appId={INTERCOM_APP_ID}>*/}
    <App />
  {/*</IntercomProvider>*/}
  </BrowserRouter>

  </React.StrictMode>,
  document.getElementById('root')
);
